export default "__VITE_ASSET__IROnCFEO__"